import { getFooter } from '../../services/footerService';
import authorizationService from '../../services/security/authorizationService';
import {
  getFooterLoaded,
  getFooterLoading,
  setFooterReceived,
  setFooterRequested,
} from './footerSlice';

export const getFooterThunk = () => async (dispatch, getState) => {
  if (
    !authorizationService.hasValidToken() ||
    getFooterLoading(getState()) ||
    getFooterLoaded(getState())
  ) {
    return;
  }

  dispatch(setFooterRequested());
  const footer = await getFooter();
  dispatch(setFooterReceived(footer));
};
